<template>
	<div class="templateHTML" v-html="$sanitize(htmlToDisplay)" />
</template>

<script>
export default {
	name: 'HTMLCard',
	props: ['htmlToDisplay']
};
</script>

<style lang="scss">
.templateHTML {
	text-align: center;
}
</style>
